import React from 'react'

function TechSelectionFacade() {
  return (
    <embed src="\pdfs\E2.5.1.3_LG-ZA-M-SB_Facade_ventilation_unit_10.2002_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionFacade